import React from 'react';
import styles from '../../styles/renewal/Forms.module.css';
import page from '../../styles/renewal/OnePage.module.css';
import useForm, { buildValidate, validators } from './useForm';
import submitInquiry from './submitInquiry';
import { formatPhone, formatThousands } from './formatters';
import { CONTACT_TOPICS } from './data';
import { TextField, SelectField, TextareaField, AgreeField } from './Fields';
import Toast from './Toast';

const INITIAL = {
  name: '',
  phone: '',
  amount: '',
  topic: CONTACT_TOPICS[0],
  company: '',
  message: '',
  agree: false,
};

const validate = buildValidate({
  name: [validators.required('성함을 입력해 주세요.')],
  phone: [
    validators.required('연락처를 입력해 주세요.'),
    validators.phone('연락처 형식을 확인해 주세요. (예: 010-1234-5678)'),
  ],
  company: [validators.required('사업장 상호를 입력해 주세요.')],
  agree: [validators.checked('개인정보 수집·이용에 동의해 주세요.')],
});

const FORMAT = { phone: formatPhone, amount: formatThousands };

const ContactForm = () => {
  const {
    values,
    status,
    submitting,
    errorOf,
    resetStatus,
    handleChange,
    handleBlur,
    handleSubmit,
  } = useForm({
    initialValues: INITIAL,
    validate,
    format: FORMAT,
    // 금액은 '만원' 단위로 입력받으므로 단위를 붙여 보낸다.
    onSubmit: (v) => submitInquiry('contact', { ...v, amount: v.amount ? `${v.amount}만원` : '' }),
  });

  const bind = (name) => ({
    name,
    value: values[name],
    onChange: handleChange,
    onBlur: handleBlur,
    error: errorOf(name),
  });

  return (
    <form className={styles.form} onSubmit={handleSubmit} noValidate>
      <div className={styles.formTitle}>상담 신청</div>

      <TextField
        id="contact-name"
        label="고객명"
        required
        placeholder="성함을 입력해 주세요"
        autoComplete="name"
        {...bind('name')}
      />

      <TextField
        id="contact-phone"
        label="연락처"
        required
        type="tel"
        inputMode="tel"
        placeholder="010-0000-0000"
        autoComplete="tel"
        {...bind('phone')}
      />

      <div className={styles.row}>
        <TextField
          id="contact-amount"
          label="신청 금액"
          placeholder="예: 3,000"
          inputMode="numeric"
          unit="만원"
          {...bind('amount')}
        />
        <SelectField
          id="contact-topic"
          label="문의 유형"
          options={CONTACT_TOPICS}
          {...bind('topic')}
        />
      </div>

      <TextField
        id="contact-company"
        label="상호명"
        required
        placeholder="사업장 상호를 입력해 주세요"
        autoComplete="organization"
        {...bind('company')}
      />

      <TextareaField
        id="contact-message"
        label="문의 내용 (선택)"
        placeholder="필요한 금액과 거래내용(도입 품목 등)을 남겨주시면 상담에 도움이 됩니다."
        {...bind('message')}
      />

      <AgreeField
        id="contact-agree"
        name="agree"
        checked={values.agree}
        onChange={handleChange}
        onBlur={handleBlur}
        error={errorOf('agree')}
      >
        개인정보 수집·이용에 동의합니다. 입력하신 정보는 상담 목적으로만 사용됩니다.
      </AgreeField>

      <Toast
        open={status === 'success' || status === 'error'}
        tone={status === 'error' ? 'error' : 'success'}
        onClose={resetStatus}
      >
        {status === 'error'
          ? '접수 중 문제가 발생했습니다. 잠시 후 다시 시도하시거나 1544-3230으로 연락해 주세요.'
          : '문의가 접수되었습니다. 영업일 기준 1~2일 내에 담당자가 연락드립니다.'}
      </Toast>

      <button
        type="submit"
        className={`${page.btn} ${page.btnPrimary} ${page.btnBlock}`}
        disabled={submitting}
      >
        {submitting ? '접수 중…' : '문의 접수하기'}
      </button>
    </form>
  );
};

export default ContactForm;
